import { render, staticRenderFns } from "./AutoThreewaySwitch.vue?vue&type=template&id=1facb179"
import script from "./AutoThreewaySwitch.vue?vue&type=script&lang=js"
export * from "./AutoThreewaySwitch.vue?vue&type=script&lang=js"
import style0 from "./AutoThreewaySwitch.vue?vue&type=style&index=0&id=1facb179&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports